/** The trading methods that have a bot illustration. */
export type VisualMethod = "signals" | "grid" | "dca" | "tradingview";

/** What the walkthrough tells its illustration, and hears back from it. */
export interface SceneRuntime {
  /** The step the example is at (1-based). While playing, the playhead decides it. */
  stage: number;
  /** The playhead runs on its own; otherwise it holds. */
  playing: boolean;
  /** Bumped when a step is chosen from the list: jump there even if it is the current step. */
  seek?: number;
  /** The playhead reached another step. */
  onStage: (stage: number) => void;
  /** 0..1 through the current step. */
  onProgress: (progress: number) => void;
}

export interface VisualProps {
  runtime: SceneRuntime;
}

/** How many events (steps) each illustration has. */
export const VISUAL_EVENTS: Record<VisualMethod, number> = {
  signals: 4,
  grid: 4,
  dca: 4,
  tradingview: 3,
};
